import { lazy } from 'react';
import type { AppModule } from '@/app/module-registry';

const LoginPage = lazy(() => import('./LoginPage'));
const RegisterPage = lazy(() => import('./RegisterPage'));
const ForgotPasswordPage = lazy(() => import('./ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('./ResetPasswordPage'));
const VerifyEmailPage = lazy(() => import('./VerifyEmailPage'));
const AcceptInvitePage = lazy(() => import('./AcceptInvitePage'));

/**
 * Rotas de conta.
 *
 * Os caminhos são em português e estáveis: eles vão dentro de e-mails
 * transacionais, e link em e-mail antigo não pode quebrar quando a rota muda.
 * Por isso nenhum deles é gerado dinamicamente.
 */
export const accountModule: AppModule = {
  key: 'account',
  order: 5,
  routes: [
    { path: 'entrar', element: <LoginPage /> },
    { path: 'cadastrar', element: <RegisterPage /> },
    { path: 'recuperar-senha', element: <ForgotPasswordPage /> },
    { path: 'redefinir-senha', element: <ResetPasswordPage /> },
    { path: 'confirmar-email', element: <VerifyEmailPage /> },
    { path: 'convite', element: <AcceptInvitePage /> },
  ],
};
